// src/components/co-ownership/CoOwnershipVision.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import {ContentCard} from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

export const CoOwnershipVision: React.FC = () => {
  const { t } = useTranslation('co_ownership');
  const visionData = t('vision', { returnObjects: true }) as any;

  return (
    <section className="bg-slate-50 py-16 md:py-24">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true, amount: 0.3 }} 
          transition={{ duration: 0.5 }} 
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{visionData.headline}</h2>
          <p className="mt-4 text-lg text-slate-600">{visionData.intro}</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {visionData.pillars.map((pillar: any, index: number) => (
            <ContentCard 
              key={index} 
              index={index} 
              icon={renderIcon(pillar.icon, { size: 24, className: 'text-emerald-500' })} 
              title={pillar.title} 
              text={pillar.text} 
              hoverEffect="lift"
              iconContainerClassName="p-3 bg-emerald-50 border-2 border-black rounded-lg w-fit"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

